import { render, staticRenderFns } from "./UserAssociationType.vue?vue&type=template&id=71810dbe&"
import script from "./UserAssociationType.vue?vue&type=script&lang=js&"
export * from "./UserAssociationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71810dbe')) {
      api.createRecord('71810dbe', component.options)
    } else {
      api.reload('71810dbe', component.options)
    }
    module.hot.accept("./UserAssociationType.vue?vue&type=template&id=71810dbe&", function () {
      api.rerender('71810dbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/UserAssociationType.vue"
export default component.exports